import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UserInfo, UserService } from '../../services/user/user.service';
import { AwardProgramInfo, AwardsService } from '../../services/awards/awards.service';
import { ApplicationService, AwardStatusInfo } from '../../services/application/application.service';
import { ErrorService } from '../../services/error/error.service';
import { SettingsService } from '../../services/settings/settings.service';

@Component({
    selector: 'app-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss']
})

export class StatusComponent implements OnInit, OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();
    User: UserInfo;
    Award: AwardProgramInfo;
    Status: AwardStatusInfo;
    ViewReady: boolean;
    RoleRightsExpanded: boolean;
    SchoolGroupsExpanded: boolean;
    PointScalesExpanded: boolean;

    constructor(
        private appSvc: ApplicationService,
        private awardSvc: AwardsService,
        private errSvc: ErrorService,
		private usrSvc: UserService,
		private settingsSvc: SettingsService) { }

    ngOnInit() {
        this.ViewReady = false;
        this.User = this.usrSvc.User;
        this.Award = this.awardSvc.CurrentAwards;
        this.RoleRightsExpanded = false;
        this.SchoolGroupsExpanded = false;
		this.PointScalesExpanded = false;

		if (this.User == null) return;

		this.settingsSvc.CurrentSchoolYearSubject.pipe(takeUntil(this._subrelease)).subscribe(year => {
			this.appSvc.GetAwardStatus(this.User.AuthToken, this.User.CurrentRole, this.Award.AwardID, year).pipe(takeUntil(this._subrelease)).subscribe(res => {
				this.Status = res;
				this.ViewReady = true;
			}, error => this.errSvc.HandleServiceError(error));
		});
    }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }


}
